// src/locales/en/business.js
export const business = {
    business: "Business",
    businessName: "Business Name",
    businessInfo: "Business Information",
    legalName: "Legal Name",
    businessAddress: "Business Address",
    businessPhone: "Business Phone",
    website: "Website",
    description: "Description",
    logo: "Business Logo",
    
    // Actions
    edit: "Edit",
    save: "Save Changes",
    cancel: "Cancel",
    
    // Placeholders
    businessNamePlaceholder: "Enter your business name",
    legalNamePlaceholder: "Enter legal business name",
    businessAddressPlaceholder: "Enter business address",
    businessPhonePlaceholder: "+94 XX XXX XXXX",
    websitePlaceholder: "https://example.com",
    descriptionPlaceholder: "Brief description of your business",
    
    // Validation
    businessNameRequired: "Business name is required",
    businessNameMinLength: "Business name must be at least 2 characters",
    legalNameRequired: "Legal name is required",
    legalNameMinLength: "Legal name must be at least 2 characters",
    invalidPhone: "Invalid phone number format",
    invalidWebsite: "Invalid website URL",
    invalidLogoFormat: "Logo must be PNG, JPG, JPEG, or WEBP",
    logoTooLarge: "Logo size must be less than 2MB",
    
    // Upload
    uploadLogo: "Upload Logo",
    removeLogo: "Remove Logo",
    changeLogo: "Change Logo",
    logoFormats: "PNG, JPG, JPEG, WEBP (Max 2MB)",
    
    // Messages
    businessUpdatedSuccess: "Business details updated successfully",
    businessUpdateError: "Failed to update business details",
    
    // Hints
    legalNameHint: "Official registered business name",
    logoSizeHint: "Recommended: Square image, at least 200x200px",

    // Feature Settings
    featureSettings: "Feature Settings",
    messageCenterShifts: "Message center shifts",
    messageCenterShiftsHelp: "Allow selecting a shift when creating/editing orders",
    crossSellingCommission: "Cross selling commission",
    crossSellingCommissionHelp: "Allow marking order items as cross-sold for commission tracking",
    stopUnverifiedDispatch: "Stop unverified order dispatching",
    stopUnverifiedDispatchHelp: "Exclude orders with an unverified payment record from packing batch creation",
    defaultSystemUser: "Default System User",
    defaultSystemUserHelp: "Choose the user shown as the actor for actions performed automatically by the system (e.g. webhook-created payments or orders)",
    noUserSelected: "No User Selected",
    orderAutoCancel: "Set order auto cancelled",
    orderAutoCancelHelp: "Automatically cancel pending orders with no verified payment after this many days. Leave empty to disable.",
    orderAutoCancelPlaceholder: "Days",
    orderAutoCancelInvalid: "Day count must be a positive whole number",
    featureSettingSaveError: "Failed to save setting"
}